import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col px-8 py-4" }
const _hoisted_2 = { class: "mb-4 text-xl font-semibold" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "font-semibold mif" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "" }, "Grade", -1)
const _hoisted_7 = { disabled: "" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "" }, "Reason", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex items-center input"
}
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "" }, "Recommendation", -1)
const _hoisted_13 = {
  key: 0,
  class: "flex items-center input"
}
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "" }, "Maneuver comments", -1)
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Saving maneuver")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Next maneuver")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")
  const _component_algolia_reason_search_component = _resolveComponent("algolia-reason-search-component")
  const _component_algolia_correction_search_component = _resolveComponent("algolia-correction-search-component")
  const _component_loading_indicator_component = _resolveComponent("loading-indicator-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.maneuver.mif.unFormattedManeuver), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, "MIF " + _toDisplayString(_ctx.maneuver.mif.value), 1)
    ]),
    (_ctx.isGradeableManeuver)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createVNode("select", {
            class: "w-full select",
            disabled: _ctx.readonly,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleGradeChange && _ctx.handleGradeChange(...args))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.gradeModel = $event)),
            placeholder: "test"
          }, [
            _createVNode("option", _hoisted_7, _toDisplayString(_ctx.defaultDropdownText), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dropdownItems, (gradeItem, index) => {
              return (_openBlock(), _createBlock("option", {
                key: index,
                value: gradeItem
              }, _toDisplayString(gradeItem.text), 9, ["value"]))
            }), 128))
          ], 40, ["disabled"]), [
            [_vModelSelect, _ctx.gradeModel]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      (_ctx.viewModel.hasReason)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.gradedManeuver.reason.display) + " ", 1),
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "ml-auto focus:outline-none",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClearReason && _ctx.handleClearReason(...args)))
                }, [
                  _createVNode(_component_fa, {
                    class: "ml-auto",
                    icon: "times",
                    type: "fas",
                    height: "18"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_algolia_reason_search_component, {
            key: 1,
            searchClient: _ctx.searchClient,
            algoliaIndex: _ctx.reasonIndex,
            optionalFiltersManeuverKeys: _ctx.optionalFiltersManeuverKeys,
            readonly: _ctx.readonly,
            class: "algolia-input",
            onKeyPress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOnReasonInputChange($event))),
            onSelectedItemEvent: _ctx.handleReasonChange,
            onEnterPress: _ctx.handleReasonInputEnterPressed
          }, null, 8, ["searchClient", "algoliaIndex", "optionalFiltersManeuverKeys", "readonly", "onSelectedItemEvent", "onEnterPress"])),
      _createVNode("span", {
        class: ["float-right ml-4 text-sm", {
          'text-red-600': _ctx.reasonCharacterCount > _ctx.reasonMaxLength
        }]
      }, _toDisplayString(_ctx.reasonCharacterCount) + "/" + _toDisplayString(_ctx.reasonMaxLength), 3)
    ]),
    _createVNode("div", _hoisted_11, [
      _hoisted_12,
      (_ctx.viewModel.hasCorrection)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.gradedManeuver.correction.display) + " ", 1),
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "ml-auto focus:outline-none",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleClearCorrection && _ctx.handleClearCorrection(...args)))
                }, [
                  _createVNode(_component_fa, {
                    class: "ml-auto",
                    icon: "times",
                    type: "fas",
                    height: "18"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_algolia_correction_search_component, {
            key: 1,
            searchClient: _ctx.searchClient,
            algoliaIndex: _ctx.correctionIndex,
            optionalFiltersReasonKeys: _ctx.optionalFiltersReasonKeys,
            readonly: _ctx.readonly,
            class: "algolia-input",
            onKeyPress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOnCorrectionInputChange($event))),
            onSelectedItemEvent: _ctx.handleCorrectionChange,
            onEnterPress: _ctx.handleCorrectionInputEnterPressed
          }, null, 8, ["searchClient", "algoliaIndex", "optionalFiltersReasonKeys", "readonly", "onSelectedItemEvent", "onEnterPress"])),
      _createVNode("span", {
        class: ["float-right ml-4 text-sm", {
          'text-red-600': _ctx.correctionCharacterCount > _ctx.correctionMaxLength
        }]
      }, _toDisplayString(_ctx.correctionCharacterCount) + "/" + _toDisplayString(_ctx.correctionMaxLength), 3)
    ]),
    _createVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createVNode("textarea", {
        disabled: _ctx.readonly,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.commentsModel = $event)),
        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.debouncedCommentChange($event.target.value))),
        class: "textarea"
      }, null, 40, ["disabled"]), [
        [_vModelText, _ctx.commentsModel]
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_loading_indicator_component, { isLoading: _ctx.isLoading }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["isLoading"]),
      _createVNode("button", {
        class: "ml-auto mr-4 focus:outline-none",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
      }, " close "),
      _createVNode(_component_button_component, {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleNextManeuver()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}